export enum FloridaPermitType {
  blanket = 'blanket',
  route = 'route',
  specific = 'specific',
  trip = 'trip',
  vehicle = 'vehicle',
  specificBlanket = 'specificBlanket',
}

export const FloridaPermitTypeValues = Object.values(FloridaPermitType);
